export default Object.freeze({
  ADD: '옵션등록',
  ADD_GUIDE: '옵션등록가이드',
  CALL_OTHER_OPTION: '다른상품 옵션 불러오기',
  COMBP_EXCEL: '조합형 엑셀양식 다운로드',
  EXCEL_DOWN: '엑셀 일괄등록',
  OPTION_INPUT: '옵션입력',
  INFO_INPUT_TYPE: '옵션정보 입력형태:',
  SELECT_TYPE: '선택형 (조합형)',
  SELECT: '선택',
  CASE1: '1건',
  CASE2: '2건',
  CASE3: '3건',
  CASE4: '4건',
  CASE5: '5건',
  BUYER: '구매자작성형',
  ADD_INPUT: '입력행 추가',
  OPTION_NAME: '옵션명',
  DIFFER: ' (\',\'로 구분)',
  OPTION_VALUE: '옵션값',
  OPTION_PRICE: '옵션가',
  PRODUCT_PRICE: '공급가',
  STOCK_CNT: '재고수량',
  WEIGHT: '무게',
  OPTION_MANAGE: '옵션관리코드',
  EXTRA_MANAGEMENT_CODE: '추가관리코드',
  DELETE: '삭제',
  EXCEL_DOWNLOAD: '엑셀 다운로드',
  OPTION_DATA_DOES_NOT_EXIST: '옵션 데이터가 존재하지 않습니다.',
  PLEASE_SELECT_INPUT_TYPE: '옵션정보 입력형태를 선택하세요.',
  IMPOSSIBLE_25: '25자까지 입력가능',
  IMPOSSIBLE_100: '100자까지 입력가능',
  IMPOSSIBLE_10: '10원단위로 입력가능',
  IMPOSSIBLE_45: '45자까지 입력가능',
  WRONG_INPUT: '입력형식이 잘못되었습니다.',
  PLEASE_IMPOSSIBLE_10: '가격은 10원 단위로 입력 가능합니다.',
  USE_INPUT: '입력 내용 적용',
  OPTION_CATEGORY: '옵션 목록',
  ALL: '총',
  SELECT_OPTION: '옵션 형태 선택 :',
  COMBO: '조합형',
  TIP_COMBO: '(※조합형으로 등록 시, 각 옵션 별로 옵션가격 / 재고수량을 등록할 수 있습니다.)',
  CASE: '건',
  SELECTED_MODIFY_ALL: '선택항목 일괄수정 :',
  USEYN: '사용여부',
  MODIFY_ALL: '일괄수정',
  IMG_ALL_REGISTER: '이미지 일괄등록',
  PRE_STOCK_CNT: '예약재고수량',
  SALE_STATUS: '판매상태',
  SALE_SETTING_STATUS: '판매설정상태',
  SALE_ABLE: '판매가능',
  SOLD_OUT: '품절',
  OPTION_NUM: '옵션번호',
  OPTION_IMG: '옵션이미지',
  STOCK: '재고',
  ABLE_SALE: '(판매가능재고)',
  SAGE_STOCK: '안전재고',
  RELEASE_STANDBY: '출고대기',
  STOCK_NUM: '재고번호',
  PRODUCT_SAVE_CREATE: '(상품 저장 후 생성)',
  TIP_OPTION_INPUT_SURE: '옵션 입력시 확인 가능합니다.',
  REGISTER_OVER: '등록완료',
  REGISTER: '등록',
  ADD_CATEGORY: '목록 추가',
  MATCH_TYPE: '매칭타입',
  EACH_PRODUCT: '상품별',
  EACH_OPTION: '옵션별',
  TIP_CREATE_BUYER_SURE: '구매자작성형 선택 시 확인 가능합니다.',
  SAVE: '저장',
  CANCEL: '취소',
  TIP_ONLY_EXCEL: '엑셀파일만 등록해주세요.',
  REPRESENT_IMG: '대표이미지URL',
  DETAIL_IMG: '상세이미지URL',
  TIP_SURE_STYLE: '파일 양식을 다시 확인해 주세요.',
  TIP_MAX_5: '옵션명은 최대 5개까지 추가 가능합니다.',
  TIP_MAX_5_OPTION: '옵션은 최대 5개까지 추가 가능합니다.',
  PLEASE_SELECT_OPTION: '옵션을 선택해주세요.',
  PLEASE_SELECT_DELETE: '삭제할 옵션을 선택해주세요.',
  SURE_REGISTER_DELETE: '입력한 옵션 중 옵션명, 옵션값이 일치하는 옵션이 없을 경우 등록된 옵션 상세 정보가 모두 삭제됩니다. 변경하시겠습니까?',
  TIP_OPTION_NAME_CORRECT: '옵션명을 정확히 입력해주세요.',
  TIP_OPTION_VALUE: '옵션값을 정확히 입력해주세요.',
  TIP_OPTION_PRICE_10: '옵션가격은 10원 단위로 입력 가능합니다.',
  TIP_SAVED: '저장되었습니다.',
  TIP_USEYN_Y_VALUE_0: '사용여부 Y, 옵션가 0인 옵션을 등록해주세요.',
  TIP_INVALID_SINGLE: '옵션 형태를 \'조합형\'으로 선택 후 옵션을 등록해주세요.',
  PLEASE_BUYER_NAME_CORRECT: '구매자작성형 옵션명을 정확히 입력해주세요.',
  TIP_USEYN_Y: '사용여부 Y인 옵션을 등록해주세요.',
  PLEASE_MODIFY: '글자수/단위를 초과한 항목이 있습니다. 수정 후 등록해 주세요.',
  PLEASE_NAME_25: '옵션명은 최대 25자 이내로 입력해주세요.',
  TIP_SPECIAL_TEXT: '옵션명에 "|" 문자는 사용하실 수 없습니다.',
  CALL_OTHER_OPTION_TTL: '다른 상품 옵션 불러오기',
  PRODUCT_NUM: '상품번호',
  PRODUCT_NAME: '상품명',
  SEARCH: '조회',
  INIT: '초기화',
  STANDARD_CATEGORY: '표준카테고리',
  PRODUCT_CATEGORY: '상품 목록',
  SURE: '확인',
  SURE_CALL_DELETE: '다른 상품 옵션을 불러올 경우 등록되어있는 옵션 정보는 삭제됩니다. 진행하시겠습니까?',
  TIP_NO_CATEGORY_INFO: '상품 목록 정보가 없습니다.',
  OPTION_IMG_REGISTER_MODIFY: '옵션 이미지 등록/수정',
  TIP_10MB: '용량 10MB 이하 파일만 등록 가능합니다.',
  TIP_IMG_1_5: '옵션 대표이미지 최대 1개, 옵션 상세이미지 최대 5개까지 등록 가능합니다.',
  TIP_IMG_REPRESENT_1: '옵션대표이미지 등록 시 옵션 상세 이미지 1개 이상 등록 필수 입니다.',
  TIP_DETAIL_REPRESENT: '옵션상세이미지 등록 시 옵션 대표 이미지 등록 필수 입니다.',
  OPTION_REPRESENT: '옵션 대표이미지',
  SELECT_FILE: '파일선택',
  OPTION_DETAIL_IMG: '옵션 상세이미지',
  MAX_10: '최대 10MB까지 가능합니다.',
  TIP_MAX_5CASE: '최대 5개까지 추가할 수 있습니다.',
  PLEASE_OPTION_REPRESENT: '옵션 대표 이미지를 등록해주세요.',
  PLEASE_OPTION_DETAIL_IMG: '옵션 상세 이미지를 등록해주세요.',
  OPTION_IMG_ALL: '옵션 이미지 일괄등록',
  TIP_IMG_NAME_NUM_SAME: '이미지 파일명을 옵션의 No. 값과 일치하게 등록해야 합니다.',
  TIP_MAX_1_DETAIL_MAX_5: '옵션 대표이미지 최대 1장, 옵션 상세이미지 최대 5장까지 등록 가능합니다.',
  TIP_FILE_NAME: '옵션 대표이미지 파일명 예시. 01.jpg, 02jpg, 03jpg',
  TIP_DETAIL_FILE_NAME: '옵션 상세이미지 파일명 예시. 01_01.jpg, 01_02.jpg, 02_01.jpg, 02_02.jpg, 03_01.jpg',
  OPTION_IMG_TTL: '옵션 이미지',
  TIP_MAX_5_REGISTER: '최대5개 등록 가능합니다.',
  TIP_GUIDE_SURE: '등록 가이드를 확인 후 업로드해 주세요.',
  TIP_ERROR_IMG: '이미지 등록 중 오류가 발생했습니다.',
  OPTION_GUIDE: '옵션 등록 가이드',
  TIP_LIST: '등록한 옵션 리스트 중 선택 할 수 있는 형태',
  TIP_NAME_5CASE: '옵션명 최대 5개 등록 가능',
  SELECT_NEED: '단계별 선택이 필수로 필요한 경우',
  REGISTER_5_ABLE: '최대 5단계까지 등록 가능',
  ALL_MORE_1_0_OPTION: '전체 옵션 중 최소 1개 이상 추가금액이 0원인 옵션 필요',
  BUYER_DIRECTLY_INPUT: '구매자가 직접 입력 값을 작성하는 형태',
  MIN_1_SET: '최소 1개 이상 노출로 설정되어 있는 옵션 필요',
  BUYER_DIRECT: '구매자 직접입력',
  SET_OPTION_REGISTER: '세트옵션등록',
  SET_OPTION_INPUT: '세트옵션입력',
  SET_OPTION: '세트옵션',
  SET_OPTION_ALL: '세트옵션 목록 총',
  IMG_MODIFY_ALL: '이미지 일괄수정',
  SEE_WIDE: '넓게보기',
  SALE_PRICE: '옵션판매가',
  PRE_STOCK: '예약재고',
  SET_CONSTITUTE_OPTION: '세트구성옵션',
  NAME_PRICE: '옵션명:옵션값',
  COUNT: '수량',
  SELLING_PRICE: '판매가',
  PLEASE_SET_OPTION_CORRECT: '세트옵션값을 정확히 입력해주세요.',
  CALL_OPTION: '구성옵션 불러오기',
  BEFORE_ADMIT: '승인완료이전',
  PRE_SALE_WAIT: '예약판매대기',
  PRE_SELLING: '예약판매중',
  PRE_SALE_OVER: '예약판매종료',
  SALE_WAIT: '판매대기',
  SELLING: '판매중',
  SELL_STOP: '판매종료',
  AVAILABLE_FOR_SALE: '판매가능',
  WAITING_PRE_SALE: '판매중지',
  PROHIBITION_SALE: '판매금지',
  SEE_ONE_EYE: '한눈에보기',
  PLEASE_OPTION: '옵션을 등록해주세요.',
  PLEASE_MORE_1: '세트옵션에 세트구성옵션을 1개 이상 등록해주세요.',
  PLEASE_MORE_10: '세트옵션의 옵션판매가를 10원 이상으로 입력해주세요.',
  PLEASE_UNDER_10_BILLION: '옵션가격은 10억원 미만으로 입력 가능합니다.',
  SALE_PRICE_RANGE_ERROR: '가격은 10억원 미만으로 입력 가능합니다.',
  PRODUCT_MANAGE_CODE: '상품관리코드',
  OPTION_LIST_ALL: '옵션 목록 총',
  SEE_15: '15개 보기',
  SEE_30: '30개 보기',
  SEE_50: '50개 보기',
  ADD_SELECTED_OPTION: '선택옵션추가',
  SELECT_LIST_ALL: '선택된 구성옵션 목록 총',
  NO_DATA: '데이터가 존재하지 않습니다.',
  PLEASE_SELECT: '선택할 옵션을 선택해주세요.',
  PLEASE_ADD: '추가할 옵션을 선택해주세요.',
  PLEASE_MAX_10_SET: '세트구성옵션은 최대 10개까지 등록 가능합니다.',
  ALREADY_ADD: '이미 추가된 옵션입니다.',
  ALREADY_ADD_SUCCESS: '이미 추가된 옵션을 제외하고 추가에 성공했습니다.',
  OPTION_NAME_PRICE: '옵션명 : 옵션값',
  SALE_ABLE_STOCK: '판매가능재고',
  SEARCH_NO_DATA: '조회 결과가 없습니다.',
  DELETABLE_N: '세트옵션으로 등록된 옵션은 삭제할 수 없습니다.',
  IMAGE1: '옵션상세이미지 등록 시 옵션대표이미지 등록 필수 입니다.',
  IMAGE2: '옵션대표이미지 등록 시 옵션상세이미지 1개 이상 등록 필수 입니다.',
  SELECTED: '선택된',
  DELETE_OPTIONS: '개의 옵션을 삭제하시겠습니까?',
  ERROR_DISCOUNT_PRICE_SET_OPTION: '세트옵션판매가는 즉시할인금액 이상으로 설정 가능합니다.',
  EMPTY_OPTION_DATA: '데이터가 존재하지 않습니다.',
  OVER_TEXT: '글자수를 초과 하였습니다.',
  NOT_REGISTRATION_TEXT: '입력 불가한 문자가 등록되었습니다.',
  NO_EXCEL_DB: 'db에 저장된 옵션이 없습니다.',
});
